//firebase.js

import firebase from 'firebase/app'
import 'firebase/firebase-messaging'

// var firebaseConfig = {
//   apiKey: "AIzaSyB2qmebVS8bRFrgd1bBZ6iInmssCQv6yhg",
//   authDomain: "fb-dbid.firebaseapp.com",
//   projectId: "fb-dbid",
//   storageBucket: "fb-dbid.appspot.com",
//   messagingSenderId: "950301482980",
//   appId: "1:950301482980:web:8f60d9a59f5029daf3b1f1",
//   measurementId: "G-KVTW5LLNFY"
// }
const firebaseConfig = {
  apiKey: "AIzaSyA-54AsMmljgzv9-Uw9Q-Vu3hFw6PDtm5I",
  authDomain: "ims-production-3a73d.firebaseapp.com",
  projectId: "ims-production-3a73d",
  storageBucket: "ims-production-3a73d.appspot.com",
  messagingSenderId: "698561070341",
  appId: "1:698561070341:web:253c12a03822be37ca236c",
  measurementId: "G-M5BVFL6DEJ"
};



firebase.initializeApp(firebaseConfig)

let messaging = null

function isSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    !/iPhone|iPad|iPod/i.test(navigator.userAgent) // block iOS
  )
}

if (isSupported()) {
  try {
    messaging = firebase.messaging()
  } catch (e) {
    console.warn('Firebase messaging not supported:', e)
  }
} else {
  console.warn('FCM not supported on this device')
}

export default messaging